import {Component, OnInit} from '@angular/core';
import {Page} from '../../../../global/util/enum/Page';
import {Constant} from '../../../../global/util/Constant';
import {NgbCalendar, NgbDateParserFormatter, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../service/auth/auth.service';
import {Dialog} from '../../../../global/util/Dialog';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {InformType} from '../../../../global/util/enum/InformType';
import {SignatureReportService} from '../../../service/signature-report.service';
import {DetailSignatureReportComponent} from '../detail-signature-report/detail-signature-report.component';
import {CustomDateParserFormatter} from '../../balance/view-balance/view-balance.component';
import {Router} from '@angular/router';
import {QueryLevel} from '../../../model/QueryLevel';
import {NgbDateStructUtil} from '../../../../global/util/NgbDateStructUtil';
import {FirstDetail} from '../../../model/FirstDetail';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';

@Component({
  selector: 'app-signature-report',
  templateUrl: './signature-report.component.html',
  styleUrls: ['./signature-report.component.css'],
  providers: [{provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}]
})

export class SignatureReportComponent implements OnInit {

  public title = 'TITLE.REPORT-OF';
  public signatureReports: FirstDetail[] = [];
  public page: any = {};
  public links: any = {};
  public enumPage = Page;
  public loading: boolean;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public headerParameters: any;
  public selectedControls: any;
  public service: string;
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(private calendar: NgbCalendar,
              public formatter: NgbDateParserFormatter,
              public signatureReportService: SignatureReportService,
              private modalService: NgbModal,
              private route: Router,
              public authenticationService: AuthService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
    this.headerParameters = LocalStorage.getHeaderParameters();
    this.selectedControls = LocalStorage.getSelectedControls();
    this.loadDefaultData();
    this.service = this.headerParameters.serviceName;
  }

  ngOnInit(): void {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
  }

  private loadDefaultData() {
    this.search();
  }

  public loadDetail(page: Page): void {
    let url;
    let partnerId;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      partnerId = this.headerParameters.partnerId;
    } else {
      partnerId = LocalStorage.getPartnerId();
    }
    switch (page) {
      case Page.First:
        url = Constant.ROOT_API_V1.concat('/firstReportDetail/search?',
          'partnerId=', String(partnerId),
          '&enterpriseId=', String(this.headerParameters.enterpriseId),
          '&workflowId=', String(this.headerParameters.workflowId),
          '&serviceId=', String(this.headerParameters.serviceId),
          '&dateFrom=', NgbDateStructUtil.toString2YYYYMMdd(this.headerParameters.fromDate),
          '&dateTo=', NgbDateStructUtil.toString2YYYYMMdd(this.headerParameters.toDate),
          '&size=' + this.pageNumber + '&sort=id,desc');
        break;
      case Page.Previous:
        url = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        url = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        url = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        url = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.getDetail(url);
  }

  private getDetail(url: string) {
    this.loading = true;
    this.signatureReportService.get(url).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.signatureReports = next._embedded.signatureReport;
      } else {
        this.signatureReports = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.processError((this.translate.instant('TITLE.REPORT-OF') + this.headerParameters.serviceName), error);
    });
  }

  public hasRole(name: string): boolean {
    return this.authenticationService.hasRole(name);
  }

  public hasTimeStamp(): boolean {
    return this.service === 'Firmas con sello de tiempo';
  }

  public getVisibilityTagPartner(): boolean {
    return this.selectedControls.queryLevel === QueryLevel.LVL_ZERO;
  }

  public getVisibilityTagEnterprise(): boolean {
    return this.selectedControls.queryLevel === QueryLevel.LVL_ONE;
  }

  back() {
    this.route.navigate(['consolidated-service-report']);
  }

  openDetailModal(firstDetail: FirstDetail) {
    const modalRef = this.modalService.open(DetailSignatureReportComponent, {
      backdrop: 'static',
      size: 'xl'
    });
    modalRef.componentInstance.from = this.headerParameters.fromDate;
    modalRef.componentInstance.to = this.headerParameters.toDate;
    modalRef.componentInstance.serviceId = this.headerParameters.serviceId;
    modalRef.componentInstance.serviceName = this.headerParameters.serviceName;
    modalRef.componentInstance.signatureReport = firstDetail;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.title = this.translate.instant('TITLE.REPORT-OF').concat(' ' + this.headerParameters.serviceName);
        this.loadDetail(Page.Self);
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  search(): void {
    this.loadDetail(Page.First);
  }

  public downloadReportOf() {
    let partnerId;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      partnerId = this.headerParameters.partnerId;
    } else {
      partnerId = LocalStorage.getPartnerId();
    }
    const url = Constant.ROOT_API_V1.concat('/firstReportDetail/download?',
      'partnerId=', String(partnerId),
      '&enterpriseId=', String(this.headerParameters.enterpriseId),
      '&workflowId=', String(this.headerParameters.workflowId),
      '&serviceId=', String(this.headerParameters.serviceId),
      '&dateFrom=', NgbDateStructUtil.toString2YYYYMMdd(this.headerParameters.fromDate),
      '&dateTo=', NgbDateStructUtil.toString2YYYYMMdd(this.headerParameters.toDate));
    this.signatureReportService.getReportOf(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = this.translate.instant('TITLE.DETAILED-REPORT');
      control.click();
      this.loading = false;
    }, error => {
      const title = this.translate.instant('TITLE.DOWNLOAD-REPORT');
      this.processError(title, error);
    });
  }

  private processError(title: string, error: any) {
    const status = error.status;
    this.title = (this.translate.instant('TITLE.REPORT-OF') + this.headerParameters.serviceName);
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }
}
